export default __webpack_public_path__ + "static/media/arrow-right.67933dff.webp";